import { useEffect } from "react";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Skeleton
} from "@chakra-ui/react";
import { obterTermoAceiteAtivo } from "store/modules/identidade/termoAceite/actions/obterTermoAceiteAtivo";
import { aceitarTermoAceite } from "store/modules/identidade/termoAceite/actions/aceitarTermoAceite";

export const ModalTermoAceite = ({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const dispatch = useAppDispatch();
  const { isRequesting, successPayload } = useTypedSelector(
    (state) => state.identidade.termoAceite.obterTermoAceiteAtivo
  );
  const { isRequesting: isPending } = useTypedSelector(
    (state) => state.identidade.termoAceite.aceitarTermoAceite
  );

  useEffect(() => {
    if (!isOpen) return;
    dispatch(obterTermoAceiteAtivo());
  }, [isOpen]);

  function aceitarTermo() {
    if (!successPayload) return;
    dispatch(
      aceitarTermoAceite({
        idTermoAceite: successPayload.id,
        onSuccess: onClose
      })
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent maxW="2xl">
        <ModalHeader>Termo de aceite</ModalHeader>
        <ModalBody pt={0}>
          <span
            dangerouslySetInnerHTML={{ __html: successPayload?.conteudo || "" }}
          />
          {isRequesting && <Skeleton h={400} />}
          <HStack mt={4} justifyContent="flex-end">
            {successPayload && (
              <Button
                variant="solid"
                colorScheme="main"
                isDisabled={isPending}
                onClick={aceitarTermo}
              >
                Aceitar
              </Button>
            )}
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
